import { catalogueLevels, measurementServiceIds, projectConfigurationTypes } from '../const';
import { isLaminate } from './is-laminate';

type TParams = {
  type: string | undefined;
  catalogueLevel: number | undefined;
  price?: number | null;
};

export const getMeasurementBannerGaParams = ({ type, catalogueLevel, price }: TParams) => {
  const isLaminateType = isLaminate(type ?? projectConfigurationTypes.INTERIOR_DOORS);
  return isLaminateType
    ? {
        projectConfigurationType: projectConfigurationTypes.LAMINATE,
        catalogueLevel: catalogueLevels.THIRD,
        price,
        elementName: 'Проекты PLP / Подбор ламината',
        productId: measurementServiceIds.LAMINATE,
      }
    : {
        projectConfigurationType: projectConfigurationTypes.INTERIOR_DOORS,
        catalogueLevel: catalogueLevel ?? catalogueLevels.SECOND,
        price,
        elementName: 'Проекты PLP / Дверь по вашим параметрам',
        productId: measurementServiceIds.INTERIOR_DOORS,
      };
};
